import React from 'react';

/**
 * Container for the Limit Simulator app.
 * Centers content, provides background, and constrains width for iframe embedding.
 */
export default function Container({ children }) {
  return (
    <div 
      className="w-full flex items-start justify-center px-2 sm:px-4 pt-0 pb-2 sm:pb-4"
      style={{ background: 'transparent' }}
    >
      {children}
    </div>
  );
} 